import { profileEn, editProfileEn } from "@/module/Profile/locale/ProfileLocaleEn.js";
import { registerEn} from "@/module/Register/locale/RegisterLocaleEn.js";
import { surpriseEn } from "@/module/SurpriseBox/locale/SurpriseLocaleEn.js";

export const en = {
    default: {
        search: 'SEARCH',
        confirm: 'CONFIRM',
        ok: 'OK',
        cancel: 'CANCEL',
        close: 'ปิด',
        connection_error: 'ไม่สามารถเชื่อมต่ออินเตอร์เน็ต<br/>กรุณาลองใหม่อีกครั้ง',
        user_expire_error: 'กรุณาเข้าสู่ระบบใหม่อีกครั้ง',
    },
    profile: profileEn,
    edit_profile: editProfileEn,
    register: registerEn,
    surprise: surpriseEn,
    otp: {
        headline: 'กรอกรหัส OTP',
        line1: 'รหัส OTP จะส่ง SMS ไปที่เบอร์',
        ref_code: 'รหัสอ้างอิง ',
        expire_in: 'รหัสจะหมดอายุภายใน ',
        second: 'วินาที',

        resend_otp: 'ขอรหัส OTP อีกครั้ง',
        err_code: 'Error Code : ',

        confirm_btn: 'ยืนยัน',
    },
    date: {
        days: 'day',
        months: 'month',
        years: 'year',
        minutes: 'minute',
        minutes_short: 'min',
        hours: 'hour',
        hours_short: 'hr',
        date_flase: 'Please select your birthday.',
        month_full: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
        month_short: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
        month_full_arr: [{ strvalue: "01", strtext: 'January' },
        { strvalue: '02', strtext: 'February' },
        { strvalue: '03', strtext: 'March' },
        { strvalue: '04', strtext: 'April' },
        { strvalue: '05', strtext: 'May' },
        { strvalue: '06', strtext: 'June' },
        { strvalue: '07', strtext: 'July' },
        { strvalue: '08', strtext: 'August' },
        { strvalue: '09', strtext: 'September' },
        { strvalue: '10', strtext: 'October' },
        { strvalue: '11', strtext: 'November' },
        { strvalue: '12', strtext: 'December' }]
    },
    redeem_button: {
        isLoading: 'กำลังดำเนินการ',
        default: 'Redeem',
        none: '',
        soldOut: 'Sorry, This reward is reaching redemption limit.',
        soldOutBuy: 'Sorry, This reward is reaching redemption limit.',
        maxPerPerson: 'Sorry, You have already redeemed this reward.',
        redeemCoolDown: 'This campaign has been used for this period.',
        nextDate: '<br/>at : ',
        exceedBuyPointLimitPerday: '',
        conditionIsInvalid: 'This campaign requires user action before redemption, please review the conditions first.',
        campaignExpired: 'Campaign has expired.',
        campaignExpiredBuy: 'Campaign has expired.',
        campaignNotAvailable: 'Sorry. This reward is not available',
        campaignNotAvailableBuy: 'Sorry. This product is not available',
        notEnoughPoint: 'Your point are not enough to redeem this campaign.',
        notSupport: 'This campaign is not support.',
        cpfProduct: {
            button: 'เฉพาะร้านค้าเท่านั้น',
            text: 'สิทธิพิเศษนี้ต้องใช้ "รหัส”จากร้านค้าในการแลกรับ กรุณากดรับสิทธิ์ที่หน้าร้านตัวแทนจำหน่ายเท่านั้น'
        },
        marketplace: 'เพิ่มลงตะกร้า',

        alert_headline: 'กรุณาเข้าระบบ',
        alert_login_msg: 'กรุณาเข้าระบบเพื่อใช้งาน',
        alert_ok_btn: 'ตกลง'
    },
    confirm_redeem: {
        confirm: "Confirm",
        cancel: "Cancel",

        headline: 'Confirm',
        pre_msg: 'คุณยืนยันที่จะ<br/>',

        free: 'Serial will available for {0} after confirm',
        free_no_timer: 'Confirm to redeem',
        free_delivery: 'Please enter shipping information to redeem',
        draw: 'Confirm to join campaign <br/> Winner will be announced after {0}',
        draw_delivery: 'Please enter shipping information to redeem',
        deal: 'Serial will available for {0} after confirm',
        deal_no_timer: 'Confirm to redeem',
        deal_delivery: 'Please enter shipping information to redeem',
        buy: 'Confirm to purchase',
        buy_delivery: 'Please enter shipping information to buy',
        interface: 'This will redirect to website after confirm',
    },
    purchase: {
        show_code: 'view code',
        code_expired: 'This serial has expired.',

        prepare: 'บริษัทจะจัดส่งให้ 14 วันทำการ',
        delivery: 'Product will be mailed based on Campaign Condition.',
        shipped: 'The Product has been delivered.',
        parcel_no: 'ParcelNo',

        not_draw1: 'Not yet drawn,',
        not_draw2: 'please check back at a later date',
        draw_winner1: 'You are the winner',
        draw_winner2: '',
        draw_not_win1: 'Sorry you are not the winner,',
        draw_not_win2: 'better luck next',
    },
    serial: {
        close_btn: 'Close',
        show_code_fix: 'กรุณาแสดง{0}นี้ให้แก่พนักงาน',
        show_code_at_shop: 'Please show code below to claim your privilege.',

        delivery: 'Product will be mailed based on Campaign Condition.',

        draw: 'Thank you for joining us.<br/>Winner will be announced after {0}',
        draw_after: 'after',

        qr_code: 'QR Code',
        barcode: 'Barcode',
        code: 'Code',

        passcode_txt: 'กรณีไม่มีเครื่อง EDC หรือ merchant system',
        passcode_btn: 'กรุณากรอก Passcode',

        expire_in: 'Expire in ',
        code_expired: 'This serial has expired.',
        code_expired_unit: ' นาที',

        // redeem_on: 'รับเมื่อ {0} เวลา {1}น.',
        redeem_on: 'รับสิทธิ์เมื่อ',

        passcode_headline: 'กรุณากรอกรหัสร้านค้า',
        passcode_sub_headline: 'ร้านค้ากรอกเพื่อยืนยันการรับสิทธิ์',

        passcode : {
            required: 'กรุณากรอก Passcode',
            too_short: 'กรุณากรอก Passcode จำนวน 5 หลัก',
            not_found: 'ข้อมูล Passcode ไม่ถูกต้อง',
            not_correct: 'ข้อมูล Passcode ไม่ถูกต้อง',
            placeholder: 'รหัสร้านค้า'
        },

        passcode_cancel: 'ยกเลิก',
        passcode_confirm: 'ยืนยัน',

        redeem_success_headline: 'รับสิทธิ์เรียบร้อยแล้ว',
        redeem_success_history: 'ดูประวัติ',
        redeem_success_close: 'ปิด',
    },
    shipping: {
        headline: 'Shipping address',
        detail_headline: 'เลือกที่อยู่จัดส่ง',
        profile_headline: 'แก้ไขที่อยู่จัดส่ง',

        detail_sub_deadline: '',
        profile_sub_headline: 'ข้อมูลในการจัดส่ง',

        add_address_btn: 'เพิ่มที่อยู่จัดส่ง',
        edit_address_btn: 'แก้ไข',
        delete_address_btn: 'ลบ',
        address_no: 'ที่อยู่',
        address_tel: 'โทร.',

        save_address_btn: 'บันทึก',

        firstname: {
            name: 'Firstname',
            placeholder: 'Firstname',
            required: 'Please enter firstname',
            too_short: '',
            invalid: '',
        },
        lastname: {
            name: 'Lastname',
            placeholder: 'Lastname',
            required: 'Please enter lastname',
            too_short: '',
            invalid: '',
        },
        address:  {
            name: 'Address',
            placeholder: 'Address',
            required: 'Please enter address',
            too_short: '',
            invalid: '',
        },
        contactnumber: {
            name: 'Contact number',
            placeholder: 'Contact number',
            required: 'Contact number',
            too_short: 'Contact number must be {0} digits',
            invalid: 'Incorrect contact number format',
        },
        nationalid: {
            name: 'National id',
            placeholder: 'National id',
            required: 'Please enter national id',
            too_short: 'National id number must be {0} digits',
            invalid: 'Incorrect national id format',
        },
        email: {
            name: 'Email',
            placeholder: 'Email',
            required: 'Please enter email address',
            too_short: '',
            invalid: 'Incorrect email format',
        },
        zipcode: {
            name: 'Zipcode',
            placeholder: 'Zipcode',
            required: 'Please enter zipcode',
            too_short: 'Zipcode must be {0} digits',
            invalid: 'Invalid zipcode',
        },
        subdistrict: {
            name: 'Sub district',
            placeholder: 'Please selece sub-district',
            required: 'Please selece sub-district',
            too_short: '',
            invalid: '',
        },
        district: {
            name: 'District',
            placeholder: 'Please selece district',
            required: 'Please selece district',
            too_short: '',
            invalid: '',
        },
        province: {
            name: 'Province',
            placeholder: 'Please selece province',
            required: 'Please selece province',
            too_short: '',
            invalid: '',
        },

        save_address: 'Save address for next privilege',
        save_address_buy: 'Save address for next puchase',

        confirm_btn: 'Confirm',
        cancel_btn: 'Cancel',

        alert_headline: 'Shipping address',
        alert_ok_btn: 'OK',

        confirm_delete_headline: 'ยืนยันลบที่อยู่',
        confirm_delete_msg: 'คุณต้องลบที่อยู่นี้ทิ้งหรือไม่',
        confirm_btn_ok: 'ยืนยัน',
        confirm_btn_cancel: 'ยกเลิก'
    },
    main: {
        home_page: "Home",
        login: "Login",
        campaign: "Campaign",
        category: 'Category',
        map: "Map",
        history: 'History',
        profile: "Profile",
        logout: "Logout",
        lang: "Language",
        msgLogout: "Logout ?",
        cancel: "Cancel",
    },
    campaign: {
        point: 'Point',
        get_point: 'Get ',
        use_point: 'Use ',
    },
    detail: {
        navbar_detail_name: 'รายละเอียด',
        navbar_news_name: 'ข่าวสารและโปรโมชั่น',
        navbar_online_cate_name: 'รายละเอียด',
        navbar_title: 'คุณ',
        navbar_point: 'มี {0} คะแนน',
        nav_point: 'คะแนน',

        news_time: '{0} เวลา {1} น.',

        detail: 'Details',
        condition: 'Conditions',

        point: 'Point',
        get_point: 'Get ',
        use_point: 'Use ',
        available_date: 'Date',

        color: {
            name: 'Color',
            placeholder: 'Please select color',
            required: 'Please select color',
        },
        size: {
            name: 'Size',
            placeholder: 'Please select size',
            required: 'Please select size',
        },
        quantity: 'เลือกจำนวน',
    },
    history: {
        point: 'Point',
        get_point: 'Get Point : ',
        use_point: 'Use Point : ',

        parcel_number: 'Parcel No. : ',
        tabbar: {
            earn: 'คะแนนที่ได้รับ',
            used: 'คะแนนที่ใช้ไป',
        }
    },
    terms: {
        headline: 'เงื่อนไขและการใช้งาน'
    },
    aboutus: {
        nav_name: 'เกี่ยวกับเรา',
        headline: 'เกี่ยวกับเรา',
        content: 'ธุรกิจอาหารสัตว์บกดำเนินธุรกิจมาเป็นเวลากว่า 70 ปี นับตั้งแต่ปี พ.ศ.2496 ภายใต้วิสัยทัศน์ “บริการแบบครบวงจร เพื่อสร้างความสำเร็จธุรกิจฟาร์ม” ด้วยพันธุ์สัตว์และอาหารสัตว์คุณภาพดี บริการวิชาการ และเทคโนโลยีจัดการฟาร์ม รวมถึงบริการตลาดรับซื้อผลิตภัณฑ์ เพื่อสร้างความสำเร็จในธุรกิจฟาร์มสุกร สัตว์ปีก ไก่ไข่ เป็ดไข่ ไก่พื้นเมือง และธุรกิจโค ตลอดจนธุรกิจร้านค้าตัวแทนจำหน่าย <br/><br/>ในวันนี้ ธุรกิจอาหารสัตว์บก มีความมุ่งมั่นที่จะส่งมอบคุณค่าทั้งในแง่คุณประโยชน์และสิทธิประโยชน์ต่างๆถึงมือลูกค้าเกษตรกรทุกคน ผ่านเครือข่ายร้านค้าตัวแทนจำหน่ายทั่วประเทศ เราจึงตั้งใจทำระบบสะสมแต้ม CPF Feed Point นี้ขึ้น เพื่อให้แน่ใจว่า ลูกค้าที่ซื้ออาหารสัตว์ของเราทุกถุงได้รับสิทธิประโยชน์และความคุ้มค่า โดยสามารถสะสมคะแนนได้จากการสั่งซื้ออาหารสัตว์ผ่านทางออนไลน์ และคะแนนที่ได้นี้ ยังนำไปใช้แลกของรางวัลได้มากมาย<br/><br/>และนี่คือส่วนหนึ่งของความตั้งใจของเรา ธุรกิจอาหารสัตว์บก ที่จะดูแลลูกค้าทุกคนอย่างดีที่สุด',
        headline_product: 'ผลิตภัณฑ์'
    },
    contactus: {
        nav_name: 'ติดต่อเรา',
        headline_1: 'ด้านผลิตภัณฑ์และบริการของซีพีเอฟ',
        content_1_line_1: 'ติดต่อ หน่วยงานพัฒนากลยุทธ์ธุรกิจ',
        content_1_line_2: 'บริษัท ซีพีเอฟ (ประเทศไทย) จำกัด (มหาชน)',
        content_1_line_3: '128 ถนนเย็นจิต แขวงทุ่งวัดดอน เขตสาทร กรุงเทพฯ 10120',

        headline_2: 'ด้านเทคนิคและการจัดส่งสินค้า',
        content_2_line_1: 'ติดต่อ หน่วยงานพัฒนากลยุทธ์ธุรกิจ',
        content_2_line_2: 'บริษัท ซีพีเอฟ (ประเทศไทย) จำกัด (มหาชน)',
        content_2_line_3: '128 ถนนเย็นจิต แขวงทุ่งวัดดอน เขตสาทร กรุงเทพฯ 10120',

        line_contact: 'Line : @cpffeedonline',
        contact_number: 'โทร : 02-036-4501'
    },
    copy: {
        req_headline: 'ขอรับสำเนาข้อมูลส่วนบุคคล​',
        send_headline: 'ส่งสำเนาข้อมูลส่วนบุคคล<br/>ให้ผู้ควบคุมข้อมูลอื่น',
        name: 'ชื่อ',
        lastname: 'นามสกุล',
        birthday: 'วันเกิด',
        tel: 'เบอร์โทร',
        age: 'อายุ',
        age_detail: 'ฉันมีอายุเกิน 20 ปีบริบูรณ์',
        email_headline: 'กรอกอีเมลสำหรับรับข้อมูล',
        email: {
            name: '',
            placeholder: '',
            required: '',
            too_short: '',
            invalid: '',
        },
        pin: 'กำหนดรหัสผ่านในการเปิดไฟล์'
    },
    tabbar: {
        reward: 'สิทธิพิเศษ',
        news: 'ข่าวสาร',
        history: 'ประวัติการใช้',
        profile: 'ข้อมูลส่วนตัว',
    },
    news_list: {
        news_headline: 'ข่าวสารและโปรโมชั่น',
        news_time: '{0} เวลา {1} น.',
        news_empty: 'ไม่พบข่าวสาร'
    },
    home: {
        text_all: 'ดูทั้งหมด',
    },
    reward: {
        title_product: 'ผลิตภัณฑ์ซีพีเอฟ',
        title_privilege: 'สิทธิพิเศษอื่นๆ',
        title_online_catalog: 'สินค้าออนไลน์',
        search_product_placeholder: 'ค้นหาผลิตภัณฑ์ซีพีเอฟ',
        search_privilege_placeholder: 'ค้นหาสิทธิพิเศษ',
        search_online_catalog_placeholder: 'ค้นหาสินค้า',
        reward_empty: 'ไม่พบสิทธิพิเศษ'
    },
    winner:{
        nav_name: 'ประกาศรายชื่อผู้โชคดี',
        label_phone: 'โทร.',
    },
    marketplace:{
        title: 'สินค้าออนไลน์',
    },
    get_friend: {
        invite_title: 'เชิญเพื่อน..รับแต้ม',
        invite_txt_point: 'เชิญเพื่อน 1 คน รับเลย 30 คะแนน',
        invite_txt_max_ppl: 'สูงสุด 3 คน',
        invite_btn: 'ชวนเพื่อนผ่านไลน์',
        friend:"Friend",
        get:"Get",
        get_friend_welcome: 'คุณได้รับเชิญมาเป็นส่วนหนึ่ง',
        get_friend_welcome2: 'ในครอบครัวอาหารสัตว์ซีพีเอฟ',

        get_friend_register: 'สมัครสมาชิก CPF Feed Point',
        get_friend_point: 'รับเลย 100 คะแนน',
        get_friend_register_btn: 'สมัครสมาชิก',
    },
    marketing: {
        title: 'ช่องทางการรับข่าวสาร',
        msg: 'ต้องการรับข้อมูลข่าวสาร',
        all: 'All',
        sms: 'SMS',
        email: 'Email',
        line: 'Line',
        btn: 'บันทึก',
        alert: {
            title: 'บันทึกการรับข่าวสารสำเร็จ',
            msg: 'คุณได้ทำการบันทึกการตั้งค่าข้อมูล<br/>การรับข่าวสารเรียบร้อยแล้ว',
            btn: 'ปิด'
        }
    },
    cookie: {
        title: 'ความยินยอมข้อมูลส่วนบุคคลของคุณ',
        msg: 'บริษัท บัซซี่บีส์ จำกัด ใช้คุกกี้เพื่อมอบประสบการณ์ การใช้งานเว็บไซต์ที่ดีที่สุดให้กับคุณ',
        detail: 'ดูรายละเอียดนโยบายความเป็นส่วนตัว',
        btn: 'ให้ความยินยอมทั้งหมด',
        btn_consent: 'ยอมรับทั้งหมด',
    },
    cookie_consent: {
        title: 'แจ้งเตือนเรื่องคุกกี้',
        text_accept: 'โดยการเข้าใช้เว็บไซต์นี้ ท่านยอมรับเงื่อนไขการใช้คุกกี้ของเรา เราใช้คุกกี้เพียงเพื่อปรับปรุงและเพิ่มประสบการณ์การใช้งานของท่านในเว็บไซต์นี้ ท่านสามารถดู รายละเอียดเพิ่มเติมได้ที่',
        text_cookie: ' นโยบายความเป็นส่วนตัว',
        btn_accept: 'ยอมรับ',
        btn_setting: 'ตั้งค่าความเป็นส่วนตัว',

        cookie_detail: {
            title: 'ความยินยอมข้อมูล<br/>ส่วนบุคคลของคุณ',
            btn_open: 'ดูเพิ่มเติม',
            btn_hide: 'ซ่อนเนื้อหา',
            btn_consent: 'ยินยอม',
            btn_unconsent: 'ไม่ยินยอม',
            btn_accept: 'ยอมรับ',
            btn_close: 'ปิด',
            warning: 'ทางเราอาจจะพัฒนาสินค้าและบริการไม่ตรงตามความต้องการของท่าน โปรดพิจารณา'
        }
    },
    age_consent: {
        title: 'กรุณายืนยันข้อมูลอีกครั้ง',
        msg: 'เนื่องจากการใช้งานแอปพลิเคชันต้อง<br/>มีอายุ 20 ปีบริบูรณ์แล้วเท่านั้น',
        btn: 'ยืนยัน',
        label: 'กรุณากรอกวันเกิด',
        birthdate: {
            name: '',
            required: 'กรุณากรอกข้อมูลให้ครบถ้วน',
            day: {
                name: 'วัน',
                placeholder: 'วัน',
                required: 'กรุณากรอกข้อมูลให้ครบถ้วน',
                too_short: '',
                invalid: '',
            },
            month: {
                name: 'เดือน',
                placeholder: 'เดือน',
                required: 'กรุณากรอกข้อมูลให้ครบถ้วน',
                too_short: '',
                invalid: '',
            },
            year: {
                name: 'ปี พ.ศ.',
                placeholder: 'ปี พ.ศ.',
                required: 'กรุณากรอกข้อมูลให้ครบถ้วน',
                too_short: '',
                invalid: '',
            }
        },
        error_age: 'อายุไม่ถึงตามเงื่อนไขที่กำหนด'
    },
    horoscope: {
        title: 'ส่งท้ายปีเก่า ต้อนรับปีใหม่ กับ อ.คฑา',
        burn_btn: 'ดูดวง',
    },
    modal_donate: {
        title: 'ขอบคุณค่ะ',
        msg: 'ขอบคุณที่ร่วมบริจาค',
        close: 'ปิด',
    }
};
